import React from "react";
import PreParser from "../components/preParser";
import Content from "../components/blocks/gco/content";
import PostTitle from "../components/blocks/core/post-title";
import QueryPagination from "../components/blocks/core/query-pagination";
import PostTerms from "../components/blocks/core/post-terms";
import TermDescription from "../components/blocks/core/term-description";
import Query from "../components/blocks/core/query";
import Layout from "../components/layout/layout";
/*
        latestPost={ props.data.wpPost }
        allPosts={ props.data.allWpPost.nodes }
*/
const PostsArchiveTemplate = (props) => {
    const postsPage = props.data.wpPage;
    let infos = {};
    if (props.pageContext.category) {
        infos = {
            postType: "category",
            title: props.data.wpCategory.name,
            path: props.pageContext,
            parents: props.pageContext.parents
        };
    }
    else {
        infos = {
            postType: "archive",
        };
    }
    const seo = props.pageContext.category
        ? props.data.wpCategory.seo
        : postsPage.seo;
    seo.nextPagePath = props.pageContext.nextPagePath;
    seo.previousPagePath = props.pageContext.previousPagePath;
    return (React.createElement(Layout, { infos: infos, seo: seo, data: props.data },
        React.createElement(PreParser, { structure: postsPage.jsonContent },
            React.createElement(Content, null, props.pageContext.category &&
                props.data.wpCategory?.richCategory?.nodes[0] ? (React.createElement(PreParser, { structure: props.data.wpCategory.richCategory.nodes[0].jsonContent })) : (React.createElement(React.Fragment, null))),
            React.createElement(PostTerms, { asList: true, asLink: true, single: props.pageContext.category ? props.data.wpCategory : undefined }, props.data.allWpCategory.nodes),
            React.createElement(TermDescription, null, props.pageContext.category
                ? props.data.wpCategory.description
                : undefined),
            React.createElement(PostTitle, null, props.pageContext.category
                ? "Catégorie : " + props.data.wpCategory.name
                : postsPage.title),
            React.createElement(Query, { allPosts: props.data.allWpPost.nodes, latestPost: props.data.wpPost },
                React.createElement(QueryPagination, { currentPage: props.pageContext.currentPage, totalPages: props.pageContext.totalPages, canonicalPath: props.pageContext.canonicalPath })))));
};
export default PostsArchiveTemplate;
